import { useEffect, useState } from "react";
import styled from "styled-components";
import { renderstatus } from "../../../designComponents/Table/renderMethods";
import { LabelText, SectionTitle, StyledCard, ValueText } from "./styles";

export const PropertyDetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  row-gap: 30px;
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const GeneralInformation = (details: any) => {
  const [propertyDetail, setPropertyDetail] = useState<any>(null);

  useEffect(() => {
    if (details) {
      setPropertyDetail(details.details);
    }
  }, [details]);
  const isComplex = propertyDetail?.property?.isComplex;
  const isProperty = !isComplex;
  const property = propertyDetail?.property;

  // config-driven fields
  const information = [
    { label: "Property Id", value: property?._id, show: true },
    { label: "Address", value: property?.address, show: true },
    { label: "Property Type", value: property?.propertyType, show: isProperty },
    { label: "Furnish Type", value: property?.furnishedType, show: true },
    { label: "Rental Market", value: property?.rentalMarket, show: true },
    {
      label: "Area (Sq.ft)",
      value: property?.area && `${property.area} Sq.ft`,
      show: isProperty,
    },
    {
      label: "Available Date",
      value: property?.availableDate,
      show: isProperty,
    },
    {
      label: "Landlord",
      value: `${property?.landlord?.firstName ?? ""} ${
        property?.landlord?.lastName ?? ""
      }`,
      show: true,
    },
    {
      label: "Rent per",
      value: property?.pricing
        ? `€ ${property.pricing.price} ${property.pricing.priceType}`
        : "",
      show: isProperty,
    },
    { label: "BER rating", value: property?.berRating, show: true },
    { label: "No. of Bedrooms", value: property?.bedrooms, show: isProperty },
    { label: "No. of Bathrooms", value: property?.bathrooms, show: isProperty },
    {
      label: "Property Creation Type",
      value: property?.propertyCreationType,
      show: isProperty,
    },
    {
      label: "Status",
      value: renderstatus(property?.status ?? ""),
      show: true,
    },
  ];

  return (
    <StyledCard style={{ margin: 0 }}>
      <SectionTitle style={{ fontSize: "1.3rem" }}>
        {propertyDetail?.property?.title ?? propertyDetail?.property?.address}
      </SectionTitle>
      <PropertyDetailGrid>
        {information
          .filter((item) => item.show && item.value)
          .map((item, idx) => (
            <DetailItem key={idx}>
              <LabelText>{item.label}</LabelText>
              <ValueText>{item.value}</ValueText>
            </DetailItem>
          ))}
      </PropertyDetailGrid>
      <DetailItem>
        <LabelText>Description</LabelText>
        <ValueText>{propertyDetail?.property?.description}</ValueText>
      </DetailItem>
    </StyledCard>
  );
};

export default GeneralInformation;
